import { useCallback, useEffect, useRef, useState } from "react";

import { useTranslation } from "react-i18next";

import TextElement from "@/components_v2/ContentElements/TextElement";
import { TextType } from "@/components_v2/ContentElements/types";

const DESCRIPTION_LINE_CLAMP = 3;

const TopicDescription = ({ description }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const containerRef = useRef(null);

  const checkTruncation = useCallback(() => {
    const el = containerRef.current?.querySelector(".ql-editor");
    if (el) {
      setIsTruncated(el.scrollHeight > el.clientHeight);
    }
  }, []);

  useEffect(() => {
    checkTruncation();
  }, [description, checkTruncation]);

  return (
    <div style={{ color: "rgba(96, 100, 108, 1)" }}>
      <div ref={containerRef}>
        <TextElement
          value={description}
          type={TextType.RICH_TEXT}
          lineClampNumber={expanded ? undefined : DESCRIPTION_LINE_CLAMP}
        />
      </div>
      {(isTruncated || expanded) && (
        <button
          onClick={() => setExpanded((prev) => !prev)}
          style={{
            background: "none",
            border: "none",
            color: "var(--primary-600)",
            cursor: "pointer",
            textDecoration: "underline",
            fontSize: "14px",
            marginTop: "8px",
            padding: 0,
          }}
        >
          {expanded ? t("buttons.showLess") : t("buttons.showMore")}
        </button>
      )}
    </div>
  );
};

export default TopicDescription;
